import { Link } from 'react-router-dom';
import type { categories } from '@/mocks/categories';

interface CategoryCardProps {
  category: (typeof categories)[number];
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-[160px] overflow-hidden">
        <img
          src={category.imageUrl}
          alt={category.name}
          title={category.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600">
            <i className={`${category.icon} text-base`}></i>
          </div>
          <h3 className="text-sm font-semibold text-background-50">
            {category.name}
          </h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
          {category.description}
        </p>
      </div>
    </Link>
  );
}